export const DEFAULT_COUPLE_SELECTION_VALUE = 'not-selected';

export enum SAMPLE_REGISTRATION_TYPE {
  ACCESS_MANUAL_REGISTRATION = 'ACCESS_MANUAL_REGISTRATION',
  ACCESS_LINK_REGISTRATION = 'ACCESS_LINK_REGISTRATION',
  API_BULK_INVITATION = 'API_BULK_INVITATION',
  API = 'API',
}
